export default {
  install(Vue) {
    Vue.prototype.$eventHandler = (method) => {
      if (method != null) {
        method();
      }
    };

    Vue.prototype.$groupBy = (xs, f) => {
      return xs.reduce(
        (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
        {}
      );
    };

    Vue.prototype.$deleteArrayObjectDuplicates = (array, filterId) => {
      return Array.from(new Map(array.map((e) => [e[filterId], e])).values());
    };
  },
};
